<fts-choice-groups *ngIf="orderableItem.choiceGroups?.length"
                   [ngClass]="{'in-modal': inItemEditorModal && !isMobile}"
                   [choices]="(choices | filterOutInstruction)"
                   [orderableChoices]="orderableItem?.choices"
                   [selectedChoiceGroup]="(choicesService.visibleChoiceGroup$ | async)"
                   [nextChoiceGroup]="nextChoiceGroup"
                   [previousChoiceGroup]="previousChoiceGroup"
                   [selectedChoice]="(choicesService.visibleChoice$ | async)"
                   [item]="item"
                   [price]="price"
                   [caloriesDisclaimer]="hasItemCalorieInfo && caloriesDisclaimer"
                   [inModal]='isInModal'
                   [choiceGroups]="orderableItem.choiceGroups"
                   [ingredientChoicesType]="ingredientChoicesType"
                   [submitBtnLabel]="addBtnLabel"
                   [submitLoadingSubscription]="updatingOrderSubscription"
                   [hasGraphicalBuilder]="hasGraphicalBuilder"
                   [orderableItem]="orderableItem"
                   [inItemEditorModal]="inItemEditorModal"
                   (choiceGroupChange)="onChoiceGroupChange($event)"
                   (choiceChange)="selectChoice($event)"
                   (halfSelectionChange)='chooseHalf($event)'
                   (qualifierSelectionChange)='toggleQualifier($event)'
                   (ingredientSelectionsChange)='toggleIngredients($event)'
                   (stageActionChange)="onStageAction($event)"
                   (submitBtnClick)="onOrderUpdate()"
                   (cancelBtnClick)="onCancelBtnClick()"
                   [isHalfAndHalf]="isHalfAndHalf">
  <ng-container *ngTemplateOutlet="itemInstructionsTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="sisterUpsellsTemplate"></ng-container>
</fts-choice-groups>

<ng-container *ngTemplateOutlet="(inItemEditorModal && !isMobile) && (!orderableItem.choiceGroups || !orderableItem.choiceGroups.length) ?
itemEditorModalHeader : undefined"
></ng-container>
<ng-container *ngIf="!orderableItem.choiceGroups || !orderableItem.choiceGroups.length">
  <div [ngClass]="{'padded-top-20 padded-bottom-20 item-choices-container': inItemEditorModal && !isMobile}">
    <ng-container *ngIf="ingredientChoicesType === ingredientChoicesTypes.Pills">
      <fts-pills-choices [choices]="(choices | filterOutInstruction)"
                         [selectedChoice]="visibleChoice"
                         [item]="item"
                         [caloriesDisclaimer]="hasItemCalorieInfo && caloriesDisclaimer"
                         [inModal]='isInModal'
                         [hasGraphicalBuilder]="hasGraphicalBuilder"
                         [ingredientChoicesType]="theme?.ingredientChoicesType"
                         [inItemEditorModal]="inItemEditorModal"
                         (choiceChange)="selectChoice($event)"
                         (halfSelectionChange)='chooseHalf($event)'
                         (qualifierSelectionChange)='toggleQualifier($event)'
                         (ingredientSelectionsChange)='toggleIngredients($event)'
                         (stageActionChange)="onStageAction($event)"
                         [isHalfAndHalf]="isHalfAndHalf"></fts-pills-choices>
    </ng-container>
  
    <ng-container *ngIf="!orderableItem.choiceGroups || !orderableItem.choiceGroups.length">
      <ng-container *ngIf="ingredientChoicesType === ingredientChoicesTypes.List">
        <div class="padded-right-20-md padded-right-20-sm padded-right-sm-down padded-left-20" [ngClass]="{'overlay': isMobile, 'padded-right-20': inItemEditorModal && !isMobile}">
          <ng-container *ngFor="let choice of choices | filterOutInstruction; trackBy: trackByChoiceFn">
            <fts-choice
              [item]="item"
              [tabbed]='false'
              [choice]='choice'
              [itemSize]='item.size'
              [isInModal]='isInModal'
              [isSelected]='(((choices | filterOutInstruction) | choiceIndex : choice) === 0 &&
                             orderableItem.itemWithRequiredIngredientChoices) || choices.length === 1'
              [caloriesDisclaimer]='hasItemCalorieInfo ? caloriesDisclaimer : ""'
              [isDependingIngredientOrdered]="choice | dependencyMet : item"
              [orderedChoice]='(item | orderedChoice : choice.name)'
              [inItemEditorModal]="inItemEditorModal"
              (chooseHalf)='chooseHalf($event)'
              (toggleIngredients)='toggleIngredients($event)'
              (toggleQualifier)='toggleQualifier($event)'
              (stageAction)="onStageAction($event)"
              [hasGraphicalBuilder]="hasGraphicalBuilder"
            ></fts-choice>
            <hr class='no-margin' aria-hidden="true">
          </ng-container>
        </div>
      </ng-container>
  
      <ng-container *ngIf='ingredientChoicesType === ingredientChoicesTypes.Steps'>
        <div class='steps-wrapper'
          #stepsWrapper
          *ngIf='hasIngredientChoices && !isMobile && !inItemEditorModal'
          [ngStyle]="{'width': isInModal ? '100%' : 'calc(100vw - ' + leftStepsWrapperPosition + ')'}">
          <div class='steps-ingredient-choices-wrapper gray-background-color'>
            <div class='steps-ingredient-choices gray-border-color fw-600' #scrollLinksWrapper>
              <div class="primary-text-color gray-border-color"></div>
              <div *ngFor="let choice of choices | filterOutInstruction; trackBy: trackByChoiceFn;"
                   #scrollLink
                   [tabindex]="!!(choice | canMoveToStepChoice : (choices | filterOutInstruction) : visibleChoice : item) ? 0 : -1"
                   [attr.aria-disabled]="!(choice | canMoveToStepChoice : (choices | filterOutInstruction) : visibleChoice : item)"
                   role="button"
                   (keypress.enter)="selectChoice(choice, $event)"
                   (keypress.space)="selectChoice(choice, $event)"
                   [attr.aria-pressed]="((choices | filterOutInstruction) | choiceIndex : choice) === ((choices | filterOutInstruction) | choiceIndex : visibleChoice)"
                   (click)="selectChoice(choice, $event)"
                   class="primary-text-color gray-border-color cursor-pointer"
                   [ngClass]="{'selection-bg-color selection-inverse-text-color selection-border-color active':
                                ((choices | filterOutInstruction) | choiceIndex : choice) === ((choices | filterOutInstruction) | choiceIndex : visibleChoice),
                   'default-cursor': !(choice | canMoveToStepChoice : (choices | filterOutInstruction) : visibleChoice : item) && !(item | valid)}">
                 <span>{{choice.name}}</span>
              </div>
            </div>
            <button
              ftsAuditableButton
              *ngIf='!isHalfAndHalf && (shouldShowSubmitBtn || isItemValid) && !isInModal'
              ftsAsyncButton [subscription]='updatingOrderSubscription'
              class='btn action-bg-color action-inverse-text-color action-btn font-secondary submit-btn text-uppercase text-nowrap'
              (click)='onOrderUpdate()'>
              {{addBtnLabel}}
            </button>
          </div>
        </div>
        <div class="choices-header" *ngIf="isMobile && visibleChoice">
          <div class="visible-choice fw-600 text-uppercase font-secondary">{{visibleChoice?.name}}</div>
          <div class="steps-controls">
            <button
              class="btn btn-sm btn-link btn-undecorated step-cksontrol padding-x"
              [ngClass]="{'selection-text-color selection-inverse-bg-color': !isFirstChoiceVisible}"
              (click)="moveToPreviousChoice()">
              <fa-icon [icon]="faAngleLeft" size="lg"></fa-icon>
              {{'component.item_editor.item_choices.back' | translate}}
            </button>
            <div class="step-control">
              {{'component.item_editor.item_choices.steps' | translate:
                {current: ((choices | filterOutInstruction) | choiceIndex : visibleChoice) + 1, maxSteps: choices.length} }}
            </div>
            <button
              class="btn btn-sm btn-link btn-undecorated padding-x"
              [ngClass]="{'selection-text-color selection-inverse-bg-color': isLastChoiceVisible && ((item | orderedChoice : visibleChoice?.name) | valid)}"
              (click)="isLastChoiceVisible ? onOrderUpdate() : moveToNextChoice();">
              {{ isLastChoiceVisible ? addBtnLabel : ('component.item_editor.item_choices.next' | translate) }}
              <fa-icon [icon]="faAngleRight" size="lg"></fa-icon>
            </button>
          </div>
        </div>
        <div class="padded-right-20 padded-left-20" [ngClass]="{'overlay padded-top-20': isMobile}">
          <div *ngIf='visibleChoice' [ngClass]="{'padded-bottom-10': isHalfAndHalf && !visibleChoice.hasHalves}">
            <p class='lead selection-text-color fw-600' id='choice-customization-title'>
              <span *ngIf="!isMobile">{{'component.item_editor.item_choices.customize_choice' | translate: {choice: visibleChoice?.name} }}</span>
  
              <span class='small fw-300 primary-text-color' [ngClass]="{'small-xs': (breakPointService.isTabletDown$ | async)}" *ngIf="visibleOrderedChoice?.warnings?.length" data-flash>
                (<span *ngIf="visibleChoice?.recommendedIngredients && (visibleOrderedChoice?.ingredients.length < visibleChoice?.recommendedIngredients)">{{'component.item_editor.item_choices.recommended_ingredients' | translate: {recommendedIngredients: visibleChoice?.recommendedIngredients} }}{{visibleOrderedChoice?.warnings.length ? '. ': ''}}</span>{{visibleOrderedChoice.warnings[0]}})
              </span>
              <span class='small fw-300 primary-text-color' [ngClass]="{'small-xs': (breakPointService.isTabletDown$ | async)}" *ngIf="visibleChoice?.recommendedIngredients && !visibleOrderedChoice?.warnings?.length && (visibleOrderedChoice?.ingredients.length < visibleChoice?.recommendedIngredients)" data-flash>
                ({{'component.item_editor.item_choices.recommended_ingredients' | translate: {recommendedIngredients: visibleChoice?.recommendedIngredients} }})
              </span>
            </p>
            <span class="fw-700 text-uppercase halfs-whole-warning" *ngIf="isHalfAndHalf && !visibleChoice.hasHalves">{{'component.item_editor.item_choices.will_be_applied_to_both_halves' | translate}}</span>
            <p class='fw-500 margin-top-5 calorie-disclaimer' *ngIf='hasItemCalorieInfo && caloriesDisclaimer'>{{caloriesDisclaimer}}</p>
          </div>
  
          <fts-choice
            *ngIf='visibleChoice'
            [item]="item"
            [choice]='visibleChoice'
            [useShortValidationMessages]='ingredientChoicesType === ingredientChoicesTypes.Steps'
            [itemSize]='item.size'
            [isInModal]='isInModal'
            [inItemEditorModal]="inItemEditorModal"
            [showValidationMessages]='false'
            [isDependingIngredientOrdered]="visibleChoice | dependencyMet : item"
            [orderedChoice]='(item | orderedChoice : visibleChoice?.name)'
            (chooseHalf)='chooseHalf($event)'
            (toggleIngredients)='toggleIngredients($event)'
            (toggleQualifier)='toggleQualifier($event)'
            (stageAction)="onStageAction($event)"
            [hasGraphicalBuilder]="hasGraphicalBuilder"
          ></fts-choice>
        </div>
      </ng-container>
    </ng-container>
  
    <ng-container *ngTemplateOutlet="itemInstructionsTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="sisterUpsellsTemplate"></ng-container>
  
    <fts-step-controls *ngIf="!isInModal  && !(isMobile && isHalfAndHalf ) && (!inItemEditorModal || isMobile) &&  ((isMobile && ingredientChoicesType !== ingredientChoicesTypes.Steps) || ingredientChoicesType === ingredientChoicesTypes.Steps)"
                       [hasBackBtn]="shouldShowBackBtn"
                       [hasForwardBtn]="shouldShowForwardBtn"
                       [hasSubmitBtn]="shouldShowSubmitBtn"
                       [isItemValid]='isItemValid'
                       [forwardBtnItemLabel]="nextChoice?.name"
                       [submitBtnLabel]="addBtnLabel"
                       [forwardBtnDisabled]="!((item | orderedChoice : visibleChoice?.name) | valid)"
                       [submitLoadingSubscription]="updatingOrderSubscription"
                       (backBtnClick)="moveToPreviousChoice()"
                       (forwardBtnClick)="moveToNextChoice()"
                       (submitBtnClick)="onOrderUpdate()"
                       [isHalfAndHalf]="isHalfAndHalf">
      <fts-price class="custom-left-content" [price]='price'></fts-price>
    </fts-step-controls>
  </div>

  <fts-item-editor-modal-footer 
    *ngIf="inItemEditorModal && !isMobile"
    [hasBackBtn]="shouldShowBackBtn"
    [hasForwardBtn]="shouldShowForwardBtn"
    [hasSubmitBtn]="shouldShowSubmitBtn"
    [forwardBtnItemLabel]="nextChoice?.name"
    [submitBtnLabel]="addBtnLabel"
    [forwardBtnDisabled]="!((item | orderedChoice : visibleChoice?.name) | valid)"
    [isItemValid]="isItemValid"
    [submitLoadingSubscription]="updatingOrderSubscription"
    [selectedChoiceGroup]="(choicesService.visibleChoiceGroup$ | async)"
    [ingredientChoicesType]="ingredientChoicesType"
    [hasChoiceGroups]="!!orderableItem.choiceGroups?.length"
    (backBtnClick)="moveToPreviousChoice()"
    (forwardBtnClick)="moveToNextChoice()"
    (submitBtnClick)="onOrderUpdate()"
    (cancelBtnClick)="onCancelBtnClick()"
    [isHalfAndHalf]="isHalfAndHalf"
></fts-item-editor-modal-footer>
</ng-container>

<ng-template #itemInstructionsTemplate>
  <div [ngClass]="{'overlay': isMobile}">
    <fts-item-instructions
      [orderableItem]='orderableItem'
      [item]="item"
      [isInModal]='isInModal'
      [(instructions)]='item.instructions'
      [inItemEditorModal]="inItemEditorModal"
      (instructionsChange)='instructionsChanged($event)'
      (chooseHalf)='chooseHalf($event)'
      (toggleIngredients)='toggleIngredients($event)'
      (toggleQualifier)='toggleQualifier($event)'
      >
    </fts-item-instructions>
  </div>
</ng-template>

<ng-template #sisterUpsellsTemplate>
  <div *ngIf="!hideUpsellItems && upsellItems?.length > 0" [ngClass]="{'overlay': isMobile}">
    <fts-sister-upsells [theme]="theme"
                        [upsellItems]="upsellItems"
                        (upsellItemAdded)="upsellItemAdded($event)"></fts-sister-upsells>
  </div>
</ng-template>

<ng-template #itemEditorModalHeader>
  <fts-item-editor-modal-header
      [isMobile]="isMobile"
      [orderableItem]="orderableItem"
      [inItemEditorModal]="inItemEditorModal"
      [ingredientChoicesType]="ingredientChoicesType"
      [trackByChoiceFn]="trackByChoiceFn"
      [item]="item"
      [choices]="choices"
      [visibleChoice]="visibleChoice"
      [submitLoadingSubscription]="updatingOrderSubscription"
      (onSelectChoice)="selectedChoice($event)"
      (loadComponent)="onLoadItemEditorModalHeaderComponent($event)"
      (cancelBtnClick)="onCancelBtnClick()"
      (submitBtnClick)="onOrderUpdate()"
    ></fts-item-editor-modal-header>
</ng-template>